import { getNumberAsMonetaryValue } from "@/utils/helpers";

export const currencyFilter = (amount, code) => {
  return getNumberAsMonetaryValue(amount, code);
};
